module.exports = {
    myHost: {
       'host':'https://api-unwmn.bitflex.xyz'
    }
};
